import React from 'react';
import { Routes, BrowserRouter, Route } from 'react-router-dom';

import Home from './pages/index';

const App = () => {
	const rawBaseName = process.env.REACT_APP_URL_PREFIX?.trim();
	const baseName = rawBaseName && rawBaseName !== '/' ? rawBaseName : undefined;

	return (
		<BrowserRouter basename={baseName}>
			<Routes>
				<Route path="/" element={<Home />} />
			</Routes>
		</BrowserRouter>
	)
}

export default App;
